<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center ">
        <a-input-search placeholder="Zoeken" style="width: 200px" class="mr-2" v-model="search" />
        <a-range-picker :placeholder="['Start dag', 'Eind dag']" class="mr-2" v-model="date" @change="onChange" />
        <a-button type="danger" @click="clearDate() " icon="close" />
      </div>
      <div class="d-flex align-items-center">
        <div class="mx-2" v-if="invoices.length > 0">
          <a-tag color="blue">
            Aantal facturen
          </a-tag>
          {{invoices.length}}
        </div>
        <div class="mx-2" v-if="factuurTotalen.totaalBetaald">
          <a-tag color="green">
            Betaald
          </a-tag>
          {{factuurTotalen.totaalBetaald | currency}}
        </div>
        <div class="mx-2" v-if="factuurTotalen.totaalNietBetaald">
          <a-tag color="red">
            Niet betaald
          </a-tag>
          {{factuurTotalen.totaalNietBetaald | currency}}
        </div>
      </div>
    </div>
    <br /><br />
    <div>
      <a-table :columns="columns" :pagination="false" :data-source="invoices" :key="invoices">
        <span slot="tags" slot-scope="text, invoice">
          <a-tag v-if="invoice.credit" color="red">
            Creditnota
          </a-tag>
          <a-tag v-if="!invoice.paid" color="red">
            Niet betaald
          </a-tag>
          <a-tag v-if="!invoice.credit_sent_at" color="red">
            Nog niet verstuurd
          </a-tag>
          <a-tag v-if="invoice.credit_sent_at" color="green">
            Verstuurd
          </a-tag>
          <a-tag v-if="invoice.paid" color="green">
            Betaald
          </a-tag>
        </span> 
        <span slot="factuurTotaal" slot-scope="invoice">
          <div v-if="invoice.organization.commission">
            {{((invoice.creditnota.invoice_reservation.reduce((total, obj) => parseFloat(obj.rate) + total,0)/100)*(100 - invoice.organization.commission_amount)) | currency}}
          </div>
          <div v-else>
            {{invoice.creditnota.invoice_reservation.reduce((total, obj) => parseFloat(obj.rate) + total,0) | currency}}
          </div>
        </span>
        <span slot="action" slot-scope="text, invoice">
          <a-dropdown-button @click="streamInvoicePDF(invoice.id, invoice)">
            Bekijk Creditnota
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="downloadInvoicePDF(invoice.id, invoice)"> <a-icon type="download" />Download Creditnota</a-menu-item>
              <a-menu-item key="2" @click="sendInvoice(invoice.id)"> <a-icon type="mail" />Verstuur creditnota naar klant</a-menu-item>
              <a-menu-item key="3" v-if="invoice.paid == false" @click="markAsPaid(invoice)"> <a-icon type="euro" />Creditnota markeren als "betaald"</a-menu-item>
              <a-menu-item key="4" v-if="invoice.paid == true" @click="markAsNotPaid(invoice)"> <a-icon type="euro" />Creditnota markeren als "niet betaald"</a-menu-item>
            </a-menu>
          </a-dropdown-button>
        </span>
      </a-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
const columns = [
  {
    title: 'Factuurnummer',
    width: 150,
    dataIndex: 'invoice_number',
    sorter: (a, b) => a.invoice_number - b.invoice_number,
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: 'Bedrijfsnaam',
    width: 200,
    dataIndex: 'organization_name',
    
    sorter: (a, b) => {
      return a.organization_name.localeCompare(b.organization_name); //using String.prototype.localCompare()
    },
    sortDirections: ['descend',  'ascend'],
  },
  {
    title: 'Aangemaakt op',
    width: 150,
    dataIndex: 'generated_at',
    defaultSortOrder: 'descend',
    // specify the condition of filtering result
    // here is that finding the name started with `value`
    sorter: (a, b) => {return moment(a.generated_at, 'YYYY-MM-DD HH:mm:ss').valueOf() - moment(b.generated_at, 'YYYY-MM-DD HH:mm:ss').valueOf()},
    customRender: (text, record, index)=>{ return moment(record.generated_at, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY')},
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: 'Verstuurd op',
    width: 200,
    dataIndex: 'credit_sent_at',
    // specify the condition of filtering result
    // here is that finding the name started with `value`
    customRender: (text, record, index)=>{return record.credit_sent_at ? 'Verstuurd op '+moment(record.credit_sent_at, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY') : 'Nog niet verstuurd'},
    sorter: (a, b) => {return moment(a.credit_sent_at, 'YYYY-MM-DD HH:mm:ss').valueOf() - moment(b.credit_sent_at , 'YYYY-MM-DD HH:mm:ss').valueOf()},
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: 'Totaal',
    width: 100,
    key: 'factuurTotaal',
    scopedSlots: { customRender: 'factuurTotaal' },
  },
  {
    title: 'Tags',
    key: 'tags',
    filters: [
      {
        text: 'Creditnota',
        value: '-credit-',
      },
      {
        text: 'Betaald',
        value: '-betaald-',
      },
      {
        text: 'Niet betaald',
        value: '-nietbetaald-',
      },
      {
        text: 'Verstuurd',
        value: '-verstuurd-',
      },
      {
        text: 'Niet verstuurd',
        value: '-nietverstuurd-',
      },
    ],
    // specify the condition of filtering result
    // here is that finding the name started with `value`
    onFilter: (value, record) => {
      let customString = "";
      if(record.credit){
        customString += "-credit-";
      }
      if(record.paid){
        customString += "-betaald-";
      }
      if(!record.paid){
        customString += "-nietbetaald-";
      }
      if(record.sent_at){
        customString += "-verstuurd-";
      }
      if(!record.sent_at){
        customString += "-nietverstuurd-";
      }
      if(customString.indexOf(value) !== -1){
        return record;
      }
    },
    scopedSlots: { customRender: 'tags' },
  },
  {
    title: 'Acties',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
  
];




  export default {
    computed: {
      user: {
        get: function () {
          return this.$store.state.user
        },
      },
    },
    watch: {
      search(){
        this.getInvoices();
      }
    },
    data(){
      return {
        date: undefined,
        startDate: undefined,
        endDate: undefined,
        invoices: [],
        search: '',
        downloadingPdf: false,
        streamPdf: false,
        columns,
        factuurTotalen:  {
          totaal: false,
          totaalBetaald: false,
          totaalNietBetaald: false
        }
      }
    },
    mounted(){
      this.getInvoices();
    },
    methods: {
      clearDate(){
        this.startDate = undefined;
        this.endDate = undefined;
        this.date = undefined;
        this.getInvoices();
      },
      onChange(date, dateString) {
        this.startDate = dateString[0];
        this.endDate = dateString[1];
      // this.reservationsLoading = true;
        this.getInvoices();
      },
      getInvoices(){
        this.$axios.get('/credits/list', {
        params: {
          search: this.search,
          startDate: this.startDate ? this.startDate : undefined,
          endDate: this.endDate ? this.endDate : undefined,
        },
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
          this.invoices = response.data;
          this.factuurTotalen = {
            totaal: false,
            totaalBetaald: false,
            totaalNietBetaald: false
          }
          this.invoices.forEach(invoice=>{
            let total;
            if(invoice.organization.commission){
              total = ((invoice.creditnota.invoice_reservation.reduce((total, obj) => parseFloat(obj.rate) + total,0)/100)*(100 - invoice.organization.commission_amount)) 
            }else{
              total = invoice.creditnota.invoice_reservation.reduce((total, obj) => parseFloat(obj.rate) + total,0)
            }
            if(invoice.paid){
              if(this.factuurTotalen.totaalBetaald === false){
                this.factuurTotalen.totaalBetaald = 0;
              }
              this.factuurTotalen.totaalBetaald += total;
            }else{
              if(this.factuurTotalen.totaalNietBetaald === false){
                this.factuurTotalen.totaalNietBetaald = 0;
              }
              this.factuurTotalen.totaalNietBetaald += total;
            }
            if(this.factuurTotalen.totaal === false){
              this.factuurTotalen.totaal = 0;
            }
            this.factuurTotalen.totaal += total
          })
        })
      },
      
      markAsPaid(invoice){
        this.$axios.post('/invoice/markAsPaid', {
          invoice_id: invoice.id
        },
        {
          headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        }
        } ).then(response => {
          this.getInvoices();
        })
      },
      markAsNotPaid(invoice){
        this.$axios.post('/invoice/markAsNotPaid', {
          invoice_id: invoice.id
        },
        {
          headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        }
        } ).then(response => {
          this.getInvoices();
        })
      },
      downloadInvoicePDF(invoice_id, invoice){
        this.downloadingPdf = true;
        this.$axios.get('/credits/download', {
        params: {
          invoice_id
        },
        responseType: 'blob',
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `Royal Parking - Creditnota #${invoice.invoice_number}.pdf`); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.downloadingPdf = false;
        })
      },
      streamInvoicePDF(invoice_id, invoice){
        this.streamPdf = true;
        this.$axios.get('/credits/stream', {
        params: {
          invoice_id
        },
        responseType: 'blob',
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
          console.log(response.data);
          let file = new Blob([response.data], { type: 'application/pdf;base64' });
          let fileURL = URL.createObjectURL(file);
          let w = window.open(fileURL);
          w.document.title = `Royal Parking - Creditnota #${invoice.invoice_number}.pdf`;
          this.streamPdf = false;
        })
      },
      sendInvoice(invoice_id){
        this.$axios.post('/credits/send', {
        invoice_id
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response=>{
        this.getInvoices();
      })
      }
    }
  }
</script>
<style>
  .credited{
    background-color: grey;
  }
</style>